/**
 * Registers ONLY the `common` module of the `ws` namespace (nav labels, buckets, kit strings). Imported by
 * workshop/nav.ts, which the always-loaded Navbar uses — so the other modules' strings stay in the v2 chunks.
 */
import { registerWsModule } from './register';
import ar from './common.ar.json';
import en from './common.en.json';

registerWsModule('common', ar, en);

export {};
